module.exports = __webpack_public_path__ + "static/img/img6.43880f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202304/img6.jpg
// module id = JOij
// module chunks = 0